import { jsCallResolve } from "doric/src/runtime/sandbox";
import { DoricPlugin } from "../DoricPlugin";
var NotificationCenter;
(function (NotificationCenter) {
    let receivers = [];
    function publish(notification) {
        receivers.filter(e => e.name === notification.name).forEach(e => {
            e.callback(notification.data);
        });
    }
    NotificationCenter.publish = publish;
    function subscribe(receiver) {
        receivers.push(receiver);
    }
    NotificationCenter.subscribe = subscribe;
    function unsubscribe(receiver) {
        receivers = receivers.filter(e => e !== receiver);
    }
    NotificationCenter.unsubscribe = unsubscribe;
})(NotificationCenter || (NotificationCenter = {}));
export class NotificationPlugin extends DoricPlugin {
    constructor() {
        super(...arguments);
        this.receivers = {};
    }
    publish(args) {
        const key = `__doric__${args.biz || ""}#${args.name}`;
        NotificationCenter.publish({
            name: key,
            data: !!args.data ? JSON.parse(args.data) : undefined
        });
        return true;
    }
    subscribe(args) {
        const key = `__doric__${args.biz || ""}#${args.name}`;
        const receiver = {
            name: key,
            callback: (data) => {
                jsCallResolve(this.context.contextId, args.callback, data);
            }
        };
        this.receivers[args.callback] = receiver;
        NotificationCenter.subscribe(receiver);
        return args.callback;
    }
    unsubscribe(subscribeId) {
        const recevier = this.receivers[subscribeId];
        if (recevier) {
            NotificationCenter.unsubscribe(recevier);
            this.receivers[subscribeId] = undefined;
            return true;
        }
        else {
            return false;
        }
    }
    onTearDown() {
        Object.entries(this.receivers).map(e => e[1]).filter(e => !!e).forEach(e => {
            if (e) {
                NotificationCenter.unsubscribe(e);
            }
        });
        this.receivers = {};
    }
}
//# sourceMappingURL=NotificationPlugin.js.map